import { create } from 'zustand'
import type { WebContainer, WebContainerProcess } from '@webcontainer/api'

interface WebContainerStore {
  instance: WebContainer | null
  isBooting: boolean
  isReady: boolean
  previewUrl: string | null
  terminalOutput: string[]
  currentProcess: WebContainerProcess | null
  error: string | null
  refreshTrigger: number
  setInstance: (instance: WebContainer) => void
  setBooting: (isBooting: boolean) => void
  setReady: (isReady: boolean) => void
  setPreviewUrl: (url: string | null) => void
  addTerminalOutput: (output: string) => void
  clearTerminalOutput: () => void
  setCurrentProcess: (process: WebContainerProcess | null) => void
  setError: (error: string | null) => void
  triggerRefresh: () => void
}

export const useWebContainerStore = create<WebContainerStore>((set) => ({
  instance: null,
  isBooting: false,
  isReady: false,
  previewUrl: null,
  terminalOutput: [],
  currentProcess: null,
  error: null,
  refreshTrigger: 0,

  setInstance: (instance) => set({ instance }),
  setBooting: (isBooting) => set({ isBooting }),
  setReady: (isReady) => set({ isReady }),
  setPreviewUrl: (previewUrl) => set({ previewUrl }),
  addTerminalOutput: (output) => set((state) => ({ 
    terminalOutput: [...state.terminalOutput.slice(-500), output] 
  })),
  clearTerminalOutput: () => set({ terminalOutput: [] }),
  setCurrentProcess: (currentProcess) => set({ currentProcess }),
  setError: (error) => set({ error }),
  triggerRefresh: () => set((state) => ({ refreshTrigger: state.refreshTrigger + 1 })),
}))
